import React, { useEffect, useRef, useState } from 'react';
import {ReactComponent as BgBtn} from '../../assets/images/bg-icon.svg';
import {ReactComponent as BgThumb1} from '../../assets/images/bg-thumb-1.svg';
import {ReactComponent as BgThumb2} from '../../assets/images/bg-thumb-2.svg';
// import {ReactComponent as BgThumb3} from '../../assets/images/bg-thumb-3.svg';
import BgThumb3 from '../../assets/images/VR.png';
import {gsap, ScrollTrigger, MotionPathPlugin } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

export default function BgExpansion({expandOnce, handleChange}) {

  let expandRef = useRef(null);
  const [expanded, setExpanded] = useState(expandOnce);

  let tl = gsap.timeline();
   

  useEffect(() => {
    if(!expanded) {
      tl.to(expandRef.current.childNodes, {
        opacity: 0,
        duration: 0.3,
        stagger: 0.1
      }).yoyo()
      gsap.to(expandRef.current, {
        opacity: 0,
        duration: 1
      });
    } else {
      gsap.to(expandRef.current, {
        opacity: 1,
        duration: 1
      });
      tl.to(expandRef.current.childNodes, {
        opacity: 1,
        duration: 0.3,
        stagger: 0.1
      }).yoyo()
      
    }
  }, [expanded])

  useEffect(() => {
    setExpanded(expandOnce);
  }, [expandOnce])

  return (
    <div
      // style={{}}
      className='cloth-expansion flex w-24 lg:w-full flex-wrap justify-center items-center'>
      <div className='z-10'>
        <button
          onClick={() => setExpanded(!expanded)}
          className='rounded-full w-12 h-12 flex justify-center items-center focus:outline-none' 
          style={{background: '#5C0BD9', zIndex: 4}}
          aria-label="Click on the button for options to swap background."
          >
          <BgBtn style={{width: '90%', height: '90%'}}/>
        </button>
      </div>
      <div
        ref={expandRef}
        className='cta-view flex bg-white rounded-lg justify-center lg:px-8 items-center pt-8 lg:pt-0'>
          <button 
            onClick={() => handleChange(1)} 
            className='w-24 interact-icon' 
            aria-label="Click to choose work space background with a chair, board, floor study lamp and two plants."
          >
            <BgThumb1 />
          </button>
          <div className='w-full text-center flex justify-center'>
            <button  
              onClick={() => handleChange(2)} 
              className='w-16 interact-icon'
              aria-label="Click to choose desktop background showing wireframes."
            >
              <BgThumb2 />
            </button>
          </div>
          <div className='w-full text-center'>
          <button 
            onClick={() => handleChange(3)} 
            className='w-10 interact-icon'
            
          >
            <img src={BgThumb3}  alt="Click to choose background showing Saturn with it's rings and two other planets."/>
            {/* <BgThumb3 /> */}
          </button>
          </div>
      </div>
    </div>
  )
}